import { useEffect, useState } from "react";

interface DashboardHeaderProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function DashboardHeader({
  activeTab,
  onTabChange,
}: DashboardHeaderProps) {
  const [mounted, setMounted] = useState(false);

  // Prevent hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col pb-4">
        <h1 className="page-title">
          Printing & Distribution Dashboard
        </h1>
        <p className="page-subtitle">
          Manage print jobs and distribution across all channels
        </p>
      </div>

      {/* Full-width tab group using grid */}
      <div className="w-full">
        <div className="grid grid-cols-2 w-full h-auto items-center justify-center rounded-md bg-muted p-1 text-muted-foreground">
          <button
            onClick={() => onTabChange("printing")}
            className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 min-h-[32px] px-3 py-1.5 w-full ${
              activeTab === "printing"
                ? "bg-white text-neutral-800 shadow-sm"
                : ""
            }`}
          >
            Printing
          </button>
          <button
            onClick={() => onTabChange("distribution")}
            className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 min-h-[32px] px-3 py-1.5 w-full ${
              activeTab === "distribution"
                ? "bg-white text-neutral-800 shadow-sm"
                : ""
            }`}
          >
            Distribution
          </button>
        </div>
      </div>
    </div>
  );
}
